import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  loginView: {
    position: 'relative',
    height: '100%',
  },
});
